export default "__VITE_ASSET__851ef50a__"